<script>
  export default {
    name: 'layout-conciliacao-embed'
  }
</script>

<template>
  <div id="page-wrapper" class="gray-bg conciliacao-embed-wrapper">
    <div class="wrapper-content animated fadeIn">
      <router-view></router-view>
    </div>
  </div>
</template>

<style>
  #page-wrapper.conciliacao-embed-wrapper {
    margin: 0;
    padding: 0;
    min-height: 100vh;
  }

  .conciliacao-embed-wrapper .wrapper-content {
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/componentes/LayoutConciliacaoEmbed.vue